import SignupForm from "@/components/Form/SignupForm";
import ViewingArticle from "@/lib/ViewingArticle";
import processStyles from "@/styles/Process.module.scss";
import { useRequireIdcLogin } from "@/hooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var __N_SSP = true;
export default function SignUp() {
  // useRequireLogout(); // 利用登録APIでログイン済みになると利用登録完了ページに遷移する前にこれが反応してトップページに飛んでしまうので使えない
  useRequireIdcLogin();
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx("div", {
      className: processStyles.container,
      children: /*#__PURE__*/_jsxs("div", {
        className: processStyles.inner,
        children: [/*#__PURE__*/_jsx("h2", {
          children: "SPOOX\u5229\u7528\u767B\u9332"
        }), /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(SignupForm, {})
        })]
      })
    })
  });
}
SignUp.layout = "NoHeaderLayout";